"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { Component, Ref, Mixins } from "vue-property-decorator";
import _ from "lodash";
import { AccountSessionMixins } from "@/service/account-session";
import UiGrid, { GridController } from "@/components/grid/UiGrid.vue";
import { APIDataSource } from "@/components/grid/data-source";
import SafetyHandleDialog from "@/views/managements/teammanager/components/dialog/SafetyHandleDialog.vue";
import DateFormat from "@/framework/timeformatter";
let RequestController = class extends Mixins(AccountSessionMixins) {
  constructor() {
    super(...arguments);
    this.searchStr = "";
    this.searchStr_dates = {};
    this.gridController = new GridController(
      new APIDataSource("api://base.auth/api/v8/application_list")
    );
    this.searchByName = _.debounce((searchStr) => {
      if (searchStr !== null && searchStr !== "") {
        this.searchStr_dates = {
          applicant: searchStr
        };
        this.searchAllData();
        return;
      }
      if (searchStr === null || searchStr === "") {
        this.searchStr_dates = null;
        this.searchAllData();
      }
    }, 500);
    this.searchAllData = _.debounce(() => {
      this.gridController.query.current = 1;
      this.gridController.query.params = null;
      if (this.searchStr_dates && this.searchStr_dates !== null) {
        this.gridController.query.params = this.searchStr_dates;
      }
      this.gridController.search();
    }, 500);
  }
  created() {
    return __async(this, null, function* () {
    });
  }
  mounted() {
    return __async(this, null, function* () {
    });
  }
  itemHandling(row) {
    this._safetyHandleDialog.open(row.application_guid, "new");
  }
  format_login_time(time) {
    if (time === 0 || time === null) {
      return "--";
    } else {
      return DateFormat.format_login_time(DateFormat.check(time));
    }
  }
  refresh() {
    return __async(this, null, function* () {
      yield this.gridController.search();
    });
  }
};
__decorateClass([
  Ref("safety-handle-dialog")
], RequestController.prototype, "_safetyHandleDialog", 2);
RequestController = __decorateClass([
  Component({
    components: {
      UiGrid,
      SafetyHandleDialog
    }
  })
], RequestController);
export {
  RequestController as default
};
